import React from 'react';
import PropTypes from 'prop-types';
import CampaignsShow from './CampaignsShow';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import fetchResourceById from 'components/hoc/fetchResourceById';
import { fetchCampaign } from 'store/actions/campaigns/fetchCampaigns';

class CampaignsShowContainer extends React.Component {
    render() {
        const {
            data,
            history,
            id,
            resource,
            resourceFetchFailed,
            resourceFetchLoading,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        if (!data) {
            return null;
        }

        return (
            <CampaignsShow
                history={ history }
                id={ id }
                record={ data }
                resource={ resource }
            />
        );
    }
}

CampaignsShowContainer.propTypes = {
    data: PropTypes.object,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const fetchValues = {
    resource: 'campaigns',
    action: fetchCampaign,
};

export default fetchResourceById(fetchValues)(CampaignsShowContainer);



// WEBPACK FOOTER //
// ./src/pages/campaigns/show/CampaignsShowContainer.js